export const en = {
    'autobudget-label': 'Autobudget priority',
    cancel: 'Cancel',
    update: 'Change'
};
